import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=02acd4fa&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"
import style0 from "./Template3.vue?vue&type=style&index=0&id=02acd4fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02acd4fa",
  null
  
)

export default component.exports